/**
 * Бөөний худалдаа — прототипийн `10 Wholesale.dc.html`.
 *
 * ⚠️ Бөөний ТҮНШИЙН ХҮСНЭГТ схемд БАЙХГҮЙ. `SaleChannel` enum-д
 *    `WHOLESALE` утга л бий — «Лангуу 1–4», «Дэлгүүр 1–4» гэсэн
 *    түншүүдийг хадгалах газар байхгүй. Энэ нь CLAUDE.md-ийн
 *    «Шийдэгдээгүй зөрүү №2» — түншийн хүснэгт хэрэгтэй эсэх.
 *
 *    Лояалти түвшин (Алт/Мөнгө/Хүрэл) нь мөн адил — `loyalty_entries`
 *    хүснэгт бий боловч v3, хоосон.
 */

import { ModuleNotice } from '../components/module-notice';

/**
 * Зэрэглэлийн өнгө нь `index.css`-ийн `--color-tier-*` токеноос —
 * inline `style` ашиглахгүй, тиймээс харанхуй горимд өөрөө дагана.
 */
const TIERS = [
  {
    name: 'Алт',
    rule: '1,500+ оноо',
    discount: '15% хөнгөлөлт',
    tone: 'bg-tier-gold-bg text-tier-gold-ink',
  },
  {
    name: 'Мөнгө',
    rule: '700–1,499 оноо',
    discount: '12% хөнгөлөлт',
    tone: 'bg-tier-silver-bg text-tier-silver-ink',
  },
  {
    name: 'Хүрэл',
    rule: '0–699 оноо',
    discount: '8% хөнгөлөлт',
    tone: 'bg-tier-bronze-bg text-tier-bronze-ink',
  },
];

export function WholesalePage() {
  return (
    <div className="flex flex-col gap-3">
      <ModuleNotice
        title="Бөөний түншийн бүртгэл хараахан ороогүй"
        blockedBy={[
          'Түнш лангуу, дэлгүүрийн бүртгэл',
          'Лояалти оноо, түвшин',
          'Бөөний захиалга',
          'Түншийг хэрхэн бүртгэхийг захиалагч шийдэх шаардлагатай',
        ]}
        ready={['Бөөний борлуулалтын суваг', 'Лояалти, эрхийн бичгийн бүртгэл']}
      />

      <div className="grid grid-cols-2 gap-3 xl:grid-cols-4">
        {[
          ['Түнш лангуу, дэлгүүр', 'бүртгэл хараахан ороогүй'],
          ['Энэ сард бөөнөөр', 'захиалга хүлээж буй'],
          ['Тэргүүлэх түншийн авсан', 'захиалга хүлээж буй'],
          ['Нийт худалдан авалт', 'захиалга хүлээж буй'],
        ].map(([label, note]) => (
          <div key={label} className="flex flex-col gap-[5px] rounded-card border border-hair bg-panel px-4 py-3.5 opacity-70">
            <span className="text-xs text-ink-2">{label}</span>
            <span className="num text-[25px] leading-[1.1] font-semibold">—</span>
            <span className="text-xs text-ink-3">{note}</span>
          </div>
        ))}
      </div>

      <div className="grid items-start gap-3 xl:grid-cols-[minmax(0,1fr)_264px]">
        <section className="flex flex-col gap-2.5 rounded-card border border-hair bg-panel px-card py-4">
          <h2 className="text-base font-semibold">Түнш лангуу, дэлгүүрүүд</h2>
          {/*
            Мөргүй, зөвхөн толгойтой хүснэгт. Гар утсанд энэ нь ганц
            хэвтээ гүйдэг зурвас болж «эвдэрсэн» мэт харагддаг тул
            sm-ээс доош нуув — доорх хоосон төлөв мэдээллийг бүтэн өгнө.
          */}
          <div className="hidden overflow-x-auto sm:block">
            <table className="w-full border-collapse text-[13px]">
              <thead>
                <tr>
                  {['Түнш', 'Төрөл', 'Нийт авсан', 'Худалдан авалт', 'Түвшин', 'Хөнгөлөлт', 'Оноо', 'Сүүлд'].map((h, i) => (
                    <th
                      key={h}
                      className={`border-b border-hair px-3 py-2 text-[11.5px] font-medium
                        tracking-wide text-ink-2 uppercase whitespace-nowrap
                        ${i >= 2 && i !== 4 ? 'text-right' : 'text-left'}`}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div className="flex flex-col items-center gap-2 py-12 text-center">
            <span className="text-sm text-ink-2">Түншийн бүртгэл байхгүй</span>
            <span className="text-[12.5px] text-ink-3">
              Түншийн бүртгэл нэмэгдсэний дараа энд гарна
            </span>
          </div>
        </section>

        <section className="flex flex-col gap-3 rounded-card border border-hair bg-panel px-card py-4">
          <h2 className="text-base font-semibold">Лояалти түвшин</h2>
          <p className="-mt-1.5 text-[11.5px] text-ink-3">
            Төлөвлөсөн дүрэм. Хараахан хэрэгжээгүй.
          </p>
          {TIERS.map((t) => (
            <div
              key={t.name}
              className={`flex flex-col gap-1.5 rounded-well px-3.5 py-2.5 opacity-80 ${t.tone}`}
            >
              <div className="flex items-baseline gap-2.5">
                <span className="text-body">{t.name}</span>
                <span className="ml-auto text-body whitespace-nowrap">{t.discount}</span>
              </div>
              <span className="text-label text-ink-2">{t.rule}</span>
            </div>
          ))}
          <span className="text-[11.5px] text-ink-3">1 оноо = 100,000₮ худалдан авалт</span>
        </section>
      </div>
    </div>
  );
}
